import { Component, Input, Output, ChangeDetectionStrategy, EventEmitter } from '@angular/core';


@Component({
  selector: 'unh-filter-project-grid-item',
  templateUrl: './filter-project-grid-item.component.html',
  styleUrls: ['./filter-project-grid-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterProjectGridItemComponent {

  @Input() projectFilter;
  @Output() clickedFilter = new EventEmitter();

  onClickFilter() {
    this.clickedFilter.emit(this.projectFilter);
  }

}
